
import { ExtraButton } from "@/models/extra-button";
import { ExtraButtonService } from "@/services/extra-button-service";
import Vue from "vue";
import { ConfirmResult } from "winfakt-vue-components";
export default Vue.extend({
	data(){
		return {
			buttons: [] as ExtraButton[]
		};
	},
	methods: {
		createNew(){
			this.$router.push(`/settings/extra-button/new`);
		},
		edit(button:ExtraButton){
			this.$router.push(`/settings/extra-button/${button.ID}`);
		},
		async deleteButton(button:ExtraButton){
			let confirm = await this.$wf.confirm(`Weet je zeker dat je ${button.Label} wilt verwijderen`, "Ja", "Nee", "Waarschuwing", "danger");
			if (confirm != ConfirmResult.YES) return;
			await ExtraButtonService.deleteButton(button);
			await this.fetchButtons();
		},
		async fetchButtons(){
			this.buttons = await ExtraButtonService.fetchButtons();
		}
	},
	async created(){
		this.fetchButtons();
	}
});
